import React from "react";
import ConstructionLogIndex from "../../components/ConstructionLog/ConstructionLogIndex";

function ConstructionLog() {
  return (
    <div className="card">
      <ConstructionLogIndex />
    </div>
  );
}

export default ConstructionLog;
